import map from 'lodash/map';

import companyRestaurantsActions from '../actionTypes/companyRestaurantsActions';

const initialState = {
  isLoading: true,
  data: {
    restaurants: [],
  },
  selectedIds: [],
};

const getSelectedRestaurantIds = (payload) => map(payload.restaurants.filter((restaurant) => restaurant.selected), 'id');

const companyRestaurantsReducer = (state = initialState, action) => {
  switch (action.type) {
    case companyRestaurantsActions.getCompanyRestaurantsMapping:
      return { ...state, isLoading: true };
    case companyRestaurantsActions.getCompanyRestaurantsMappingSuccess:
      return {
        ...state,
        ...action.payload,
        selectedIds: getSelectedRestaurantIds(action.payload.data),
        isLoading: false,
      };
    case companyRestaurantsActions.getCompanyRestaurantsMappingFailed:
      return {
        ...state,
        ...action.payload,
        isLoading: false,
      };
    case companyRestaurantsActions.updateCompanyRestaurantsMapping:
      return {
        ...state, isSubmitting: true,
      };
    case companyRestaurantsActions.updateCompanyRestaurantsMappingFailed:
    case companyRestaurantsActions.updateCompanyRestaurantsMappingSuccess:
      return {
        ...state,
        isSubmitting: false,
        updateSuccess: true,
      };
    case companyRestaurantsActions.resetToInitialState:
      return initialState;
    default:
      return state;
  }
};

export default companyRestaurantsReducer;
